
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
    props: {
        value: {
            type: Boolean,
        },
        userId: {
            type: Number,
        },
        ticketId: {
            type: Number,
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState('texts', ['confirmation']),
    },
    methods: {
        async confirm() {
            try {
                this.loading = true;
                await this.$hipApi.markTicketAsUsed(
                    this.userId,
                    this.ticketId,
                );
                this.$emit('input', false);
                this.$emit('onTicketUsed');
            } catch (err) {
                this.$notifier.showError(
                    err?.error?.message || err?.message || err,
                );
            }
            this.loading = false;
        },
    },
});
